import { View } from '@react-pdf/renderer';
import { checkIsEmptyDataByKey } from 'PDF/helpers/pdfMapping';
import { globalStyles } from 'PDF/styles';

import { Header } from './Header';
import { Row } from './Row';
import { Units } from './Units';
import { SmallHeading } from '../SmallHeading';

export type RowType =
  | 'regularText'
  | 'boldBackgroundGray'
  | 'boldBlackText'
  | 'boldGreenText'
  | 'regularGrayText'
  | 'boldDarkGreen';

export interface IFinBlockTableRowItem {
  type: RowType;
  heading: string;
  values?: (string | number)[];
  valuesType?: RowType;
}

export interface IFinBlockTableProps {
  heading?: string;
  unit?: string;
  headers: (string | number)[];
  rows?: IFinBlockTableRowItem[];
  hasLeftHeading?: boolean;
  isRatiosTable?: boolean;
  isAlwaysNumberFloat?: boolean;
  firstColumnWidth?: number;
  noBorderBeforeTotal?: boolean;
  headingStyles?: object;
}

export const FinBlockTable = ({
  heading,
  unit,
  headers,
  rows,
  hasLeftHeading = false,
  isRatiosTable = false,
  isAlwaysNumberFloat = false,
  firstColumnWidth,
  noBorderBeforeTotal = false,
  headingStyles = {},
}: IFinBlockTableProps) => {
  if (!rows || checkIsEmptyDataByKey(rows, 'values')) {
    return null;
  }
  return (
    <>
      <View minPresenceAhead={90} />
      <View style={globalStyles.marginBottom}>
        {heading && <SmallHeading heading={heading} containerStyles={headingStyles} />}
        <View fixed wrap={false}>
          {unit && <Units unit={unit} />}
          <Header
            dates={headers}
            hasLeftHeading={hasLeftHeading}
            isRatiosTable={isRatiosTable}
            firstColumnWidth={firstColumnWidth}
          />
        </View>
        {rows?.map((value, index) => (
          <Row
            key={index}
            data={value}
            isRatiosTable={isRatiosTable}
            isAlwaysNumberFloat={isAlwaysNumberFloat}
            firstColumnWidth={firstColumnWidth}
            noBorderBeforeTotal={noBorderBeforeTotal && index === rows.length - 2}
          />
        ))}
      </View>
    </>
  );
};
